import {useMemo} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";

export default function Schedule({ data, title }) {
    const schedules = data?.garrison?.schedules ?? [];

    const columnDefs = useMemo(() => ([
        { headerName: "Status", field: "statusText", flex: 0.7 },
        { headerName: "Programada (duração)", field: "startText", flex: 1 },
        { headerName: "Realizada (duração)", field: "dispatchStart", flex: 1 },
        { headerName: "Natureza", field: "reason", flex: 1 },
        { headerName: "Prioridade", field: "priority", flex: 0.7 },
        { headerName: "Endereço", field: "placeDescr", flex: 1 },
        { headerName: "Descrição", field: "description", flex: 1 },
    ]), []);

    const makeScheduleRows = (schedule) => {
        return (schedule.activities ?? []).map((activity) => {
            const dispatchStart = activity?.dispatchList?.length
                ? activity.dispatchList
                    .map((dispatch) => {
                        return `${dispatch.numberCheckbook ?? ""} - ${dispatch.dispatchStart ?? ""}`;
                    })
                    .join(" | ")
                : "";

            return {
                statusText: activity.statusText ?? "",
                startText: activity.startText ?? "",
                dispatchStart,
                reason: activity.reason ?? "",
                priority: activity.priority ?? "",
                placeDescr: activity.placeDescr ?? "",
                description: activity.description ?? "",
            }
        })
    }

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            {schedules.map((schedule) => {
                const rows = makeScheduleRows(schedule);

                return (
                    <section key={schedule.id} className="print:hidden">
                        <h3 className="text-[16px]! text-[#676a7c]">{schedule.name}</h3>
                        <div className="w-full">
                            <AgGridReact
                                rowData={rows}
                                columnDefs={columnDefs}
                                defaultColDef={{
                                    resizable: true,
                                    wrapText: true,
                                    autoHeight: true,
                                }}
                                animateRows={false}
                                suppressCellFocus={true}
                                suppressRowHoverHighlight={true}
                                gridOptions={{ localeText: AgGridUtils.localization() }}
                                theme={AgGridUtils.generalTheme({ headerTextColor: "#676a6c" })}
                                domLayout="autoHeight"
                            />
                        </div>
                    </section>
                )
            })}
            {schedules.map((schedule) => {
                const rows = makeScheduleRows(schedule);

                return (
                    <section key={schedule.id} className="hidden print:block">
                        <h3 className="text-[16px]! text-[#676a7c]">{schedule.name}</h3>
                        <div className="w-full rounded-lg overflow-hidden border border-[#e0e1e3]">
                            <table className="w-full border border-[#e0e1e3] border-collapse table-fixed text-[14px]">
                                <thead>
                                <tr>
                                    {columnDefs.map((col) => (
                                        <th key={col.field} className="p-2 bg-[#efefef] border border-[#e0e1e3] text-start text-[#676a7c]">{col.headerName}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            {columnDefs.map((col) => (
                                                <td
                                                    key={col.field}
                                                    className={[
                                                        index % 2 === 0 ? "bg-white" : "bg-[#efefef]",
                                                        "p-1 border border-[#e0e1e3] break-words align-top",
                                                    ].join(" ")}
                                                >
                                                    {row[col.field]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                )
            })}
        </div>
    )
}